import type { TFICDocument } from '../types/Document.ts';

export type DocumentAction = 'mark_as_credit_card_statement' | 'delete';

export type DocumentActionBlocker = 'unsaved_changes' | 'processing' | 'matched' | 'booked' | 'fixed_asset';

export type DocumentActionAvailability = {
    visible: boolean;
    blocker: DocumentActionBlocker | null;
};

export type DocumentActionsDocument = Pick<
    TFICDocument,
    'document_category' | 'status' | 'is_matched' | 'is_booked' | 'fixed_asset' | 'bill_id'
>;

function lockedBillBlocker(document: DocumentActionsDocument): DocumentActionBlocker | null {
    if (document.is_booked === true) return 'booked';
    if (document.fixed_asset) return 'fixed_asset';
    return null;
}

function billBlocker(document: DocumentActionsDocument): DocumentActionBlocker | null {
    return document.is_matched ? 'matched' : lockedBillBlocker(document);
}

export function deleteUnmatchesFirst(document: DocumentActionsDocument): boolean {
    return document.is_matched && document.bill_id !== null;
}

export function documentActionAvailability(
    document: DocumentActionsDocument,
    hasUnsavedChanges: boolean,
): Record<DocumentAction, DocumentActionAvailability> {
    const unsavedBlocker: DocumentActionBlocker | null = hasUnsavedChanges ? 'unsaved_changes' : null;
    const processingBlocker: DocumentActionBlocker | null = document.status === 'running' ? 'processing' : null;
    const isBillable = document.document_category === 'invoice' || document.document_category === 'pos_receipt';
    const deleteBlocker = deleteUnmatchesFirst(document) ? lockedBillBlocker(document) : billBlocker(document);

    return {
        mark_as_credit_card_statement: {
            visible: isBillable,
            blocker: unsavedBlocker ?? processingBlocker ?? billBlocker(document),
        },
        delete: {
            visible: true,
            blocker: unsavedBlocker ?? deleteBlocker,
        },
    };
}
